import React, { Component } from 'react'
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import { 
    getAvailableProducts,
    getBundleProducts,
    getUnavailableProducts,
    isFetchingPrypoolProducts,
    getUserSelectedProducts,
    getProductsForCheckout,
    getDuplicatedProducts,
    checkIfProductIsInBundles
 } from '../../store/prypool_products/selectors';

import { fetchProducts, checkoutProducts } from '../../store/prypool_products/operations';
import { pushProduct, removeProduct } from '../../store/prypool_products/creators';

import LoadingIndicator from "../../components/LoadingIndicator";
import AvailableProducts from '../../components/PrypoolProduct/AvailableProductsContainer';
import BundleProducts from '../../components/PrypoolProduct/BundleProductsContainer';
import UnavailableProducts from '../../components/PrypoolProduct/UnavailableProductsContainer';
import { Button } from "@blueprintjs/core";

class PrypoolProductsList extends Component {

    componentDidMount(){
        this.props.fetchProducts(this.props.pool_id);
    }

    productClicked=(product)=>{
        if(this.props.selected_products && this.props.selected_products.hasOwnProperty(product.id)){
            this.props.removeProduct(product);
            return;
        }

        if(product.metadata.is_bundle === 'true'){
            const products_to_remove = this.props.getDuplicatedProducts(product);  
            products_to_remove.forEach(product_to_remove=>{
                this.props.removeProduct(product_to_remove);
            })  
        }else{
            const product_is_in_bundle = this.props.checkIfProductIsInBundles(product);
            if(product_is_in_bundle) return;
        }
        this.props.pushProduct(product);
    }

    checkoutProducts=()=>{
        const products = this.props.getProductsForCheckout();
        checkoutProducts(products, this.props.pool_id);
    }

    render() {
        const {is_loading, selected_products, available_products, bundle_products, unavailable_products} = this.props;
       
        return (
            <div className="prylpool-products-container">
                {
                    is_loading && <LoadingIndicator />
                }
                
                <AvailableProducts available_products={available_products} selected_products={selected_products} productClicked={this.productClicked} />

                <BundleProducts bundle_products={bundle_products} selected_products={selected_products} productClicked={this.productClicked} />

                <UnavailableProducts unavailable_products={unavailable_products} selected_products={selected_products} productClicked={this.productClicked} />

                <Button className="checkout-button" role="link" intent="primary" onClick={this.checkoutProducts} disabled={selected_products?false:true} >
                    <Translate value='prypool.checkout' />
                </Button>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    locale: state.i18n.locale,
    available_products: getAvailableProducts(state),
    bundle_products: getBundleProducts(state),
    unavailable_products: getUnavailableProducts(state),
    is_loading: isFetchingPrypoolProducts(state),
    selected_products: getUserSelectedProducts(state),
    getProductsForCheckout: _=>getProductsForCheckout(state),
    getDuplicatedProducts: (bundle)=>getDuplicatedProducts(state, bundle),
    checkIfProductIsInBundles: (product)=>checkIfProductIsInBundles(state, product)
});

const mapDispatchToProps={
    fetchProducts,
    pushProduct,
    removeProduct
};

  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(PrypoolProductsList);
  